/**
 * Every status getSchoolStatus can return, in its priority order. The status
 * legend lists all of them, not only the ones in the current table (PD slides 43-44).
 */
export const SCHOOL_STATUS_ORDER = ['Dormant', 'Data weak', 'Low coverage', 'High risk', 'Active', 'Growth Opportunity'];

/**
 * Calculates school status based on status count values and fixed priority hierarchy.
 * Priority order:
 * 1. Dormant
 * 2. Data weak
 * 3. Low coverage
 * 4. High risk
 * 5. Active
 * 6. Growth
 *
 * Each status is evaluated as true if its value is >= 1.
 *
 * @param {Object} statusData - Object containing values for each status
 * @returns {string} - Computed status string
 */
export const getSchoolStatus = (statusData = {}) => {
    const {
        dormant = 0,
        dataWeak = 0,
        lowCoverage = 0,
        highRisk = 0,
        active = 0,
        growth = 0,
    } = statusData;

    if (Number(dormant) >= 1) return 'Dormant';
    if (Number(dataWeak) >= 1) return 'Data weak';
    if (Number(lowCoverage) >= 1) return 'Low coverage';
    if (Number(highRisk) >= 1) return 'High risk';
    if (Number(active) >= 1) return 'Active';
    if (Number(growth) >= 1) return 'Growth Opportunity';

    return 'None';
};
